import { Injectable } from '@angular/core';

import { AppUserClaimsService } from '../services/app-user-claims.service';
import { AppStateService } from '../services/app-state.service';
import { ClHeaderComponent } from '@mitel/cloudlink-console-components';

@Injectable({
  providedIn: 'root'
})
export class SupportPortalGuard  {
  constructor(
    private appUserClaimsSvc: AppUserClaimsService,
    private appStateService: AppStateService,
    private clHeader: ClHeaderComponent
  ) {}

  /*
  This guard may change as we allow Global_Admin to assume role.
  */
  canActivate(): boolean {
      let supportMode = this.appStateService.getSupportPortalMode();
      let claims = this.appUserClaimsSvc.getClaims();
      let assumed = this.appUserClaimsSvc.isAssumedRole();
      if(supportMode && claims.role === 'GLOBAL_ADMIN' && !assumed) {
        console.log("Support Portal Guard says: ", true);
        return true;
      } else {
        console.log("Support Portal Guard says: ", false);
        this.clHeader.logoutUser();
        return false;
      }
  }
}